module.exports = __webpack_public_path__ + "static/media/city-and-guilds.e4b3ebbd.png";